import React, { useEffect } from 'react';
import { Box, Typography, Pagination, TextField, MenuItem } from '@mui/material';
import { useActivityManagement } from '../../../hooks/useActivityManagement';
import SearchBar from '../common/SearchBar';
import ActivityTable from '../tables/ActivityTable';

const ActivityTab = ({ showNotification }) => {
  const {
    activities,
    loading,
    currentPage,
    totalPages,
    totalItems,
    searchTerm,
    typeFilter,
    setSearchTerm,
    setTypeFilter,
    loadActivities,
    getFilteredActivities,
    handleSearch,
    handlePageChange,
  } = useActivityManagement();

  useEffect(() => {
    loadActivities();
  }, [loadActivities]);

  const handleSearchSubmit = (value) => {
    handleSearch(value);
  };

  const filteredActivities = getFilteredActivities();

  const activityTypes = [
    { value: 'all', label: 'All Types' },
    { value: 'new_tab_open', label: 'New Tab Open' },
    { value: 'page_view', label: 'Page View' },
    { value: 'page_duration', label: 'Page Duration' },
    { value: 'document_view', label: 'Document View(subset of page_view)' },
    {
      value: 'document_action',
      label: 'Document Action (share/print/bookmark/unbookmark)',
    },

    { value: 'interaction', label: 'Interaction (click btn or link/keypress)' },
    { value: 'scroll', label: 'Scroll' },
    { value: 'session_end', label: 'Session End' },

    // { value: 'search_interaction', label: 'Search Interaction' },
    // { value: 'custom_event', label: 'Custom Event - User logged in' },
  ]

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 3,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Recent Activity
        </Typography>
      </Box>

      <Box sx={{ mb: 3, display: 'flex', gap: 2, alignItems: 'flex-start' }}>
        <SearchBar
          value={searchTerm}
          onChange={setSearchTerm}
          onSearch={handleSearchSubmit}
          placeholder="Search by email or path..."
          fullWidth
        />
        
        <TextField
          select
          label="Activity Type"
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
          size="small"
          sx={{ 
            minWidth: 200,
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
            }
          }}
        >
          {activityTypes.map((type) => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      <ActivityTable
        activities={filteredActivities}
        loading={loading}
        searchTerm={searchTerm}
        typeFilter={typeFilter}
      />

      {totalPages > 1 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mt: 3,
            gap: 2,
          }}
        >
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(event, page) => handlePageChange(page)}
            color="primary"
            showFirstButton
            showLastButton
          />
          <Typography variant="body2" color="text.secondary">
            Total: {totalItems} activities
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ActivityTab;
